"use client";
import { useRollbar } from './useRollbar.js';

function useRollbarConfiguration(config) {
  var rollbar = useRollbar();
  rollbar.configure(config);
}

export { useRollbarConfiguration };
//# sourceMappingURL=useRollbarConfiguration.js.map
